import React from 'react';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import PropTypes from 'prop-types';

import { ROUTE_NAME_TPLS } from '../../../../../entities/logistic/logisticTasks/redux/logisticTasksPetrol.slice';
import FormDialog from '../../../../../shared/ui/FormDialog/FormDialog';
import FormDialogButtons from '../../../../../shared/ui/FormDialog/FormDialogButtons';
import SelectedVehiclesList from './SelectedVehiclesList/SelectedVehiclesList';

export default function CreateRoutesDialog({
  open,
  handleClose,
  selectedVehicles,
  availableTankers,
  routeNameTemplate,
  setRouteNameTemplate,
  processCreateRoutes,
  loading,
}) {
  return (
    <FormDialog
      disableTextField
      open={open}
      handleClose={handleClose}
      hideButtons
      dialogContent={
        <>
          {!!selectedVehicles.length && (
            <SelectedVehiclesList selectedVehicles={selectedVehicles} availableTankers={availableTankers} />
          )}
          <FormControl fullWidth sx={{ mt: 2 }}>
            <InputLabel id="route-name-tpl">Шаблон имени маршрута</InputLabel>
            <Select
              id="route-name-tpl"
              labelId="route-name-tpl"
              value={routeNameTemplate}
              onChange={(evt) => setRouteNameTemplate(evt.target.value)}
              label="Шаблон имени маршрута"
            >
              {ROUTE_NAME_TPLS.map(({ value, label }) => (
                <MenuItem key={value} value={value}>
                  {label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormDialogButtons onClose={handleClose} loading={loading} onClick={processCreateRoutes} />
        </>
      }
      title="Создание маршрутов"
      saveTitle="Создать"
      cancelTitle="Отмена"
    />
  );
}
CreateRoutesDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  selectedVehicles: PropTypes.arrayOf(PropTypes.string).isRequired,
  availableTankers: PropTypes.arrayOf(
    PropTypes.shape({
      registrationNum: PropTypes.string,
      color: PropTypes.string,
    }),
  ),
  routeNameTemplate: PropTypes.string.isRequired,
  setRouteNameTemplate: PropTypes.func.isRequired,
  processCreateRoutes: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
};
CreateRoutesDialog.defaultProps = {
  availableTankers: [],
};
